<template>
    <div
        :class="[
            'rounded-md p-4 mb-3 border',
            available
                ? 'bg-white border-gray-200'
                : 'bg-gradient-to-br from-royal-blue-50 to-white border-royal-blue-200'
        ]"
    >
        <div class="flex items-center gap-1.5 mb-1">
            <h2 class="text-base font-semibold text-gray-900">{{ $t('people_block.title') }}</h2>
            <SparklesIcon class="w-4 h-4 text-royal-blue-600" :title="$t('people_block.ai_badge')" aria-label="AI" />
        </div>
        <p class="text-xs text-gray-600 leading-relaxed" :class="{'mb-2': !available}">
            {{ $t('people_block.promo_description') }}
            <a
                :href="helpUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="text-royal-blue-600 hover:text-royal-blue-700 hover:underline font-medium"
            >{{ $t('people_block.learn_more_button') }}</a>
        </p>
        <p v-if="available" class="text-xs text-gray-400 mt-1">
            {{ $t('people_block.promo_enable_in_settings') }}
        </p>
        <div v-else class="flex items-center flex-wrap gap-2">
            <router-link
                to="/subscription"
                class="inline-flex items-center rounded-md bg-royal-blue-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-royal-blue-700 transition-colors"
            >{{ $t('people_block.promo_upgrade_cta') }}</router-link>
            <span class="text-xs text-gray-500">{{ $t('people_block.promo_plan_required') }}</span>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {SparklesIcon} from "@heroicons/vue/20/solid";

const HELP_BASE_URL = 'https://gallera.resplie.com/galleries/face-recognition';

export default defineComponent({
    name: "PeoplePromoBlockComponent",

    components: {
        SparklesIcon,
    },

    props: {
        available: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        helpUrl(): string {
            return this.$i18n.locale === 'en'
                ? `${HELP_BASE_URL}?lang=en`
                : HELP_BASE_URL;
        },
    },
});
</script>
